// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.support.RentalManagerGuestSupportWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerGuestSupportWebApiHandler_getHelpArticles,
  RentalManagerGuestSupportWebApiHandler_getHelpArticles_Path,
  RentalManagerGuestSupportWebApiHandler_getHelpTopics,
  RentalManagerGuestSupportWebApiHandler_getHelpTopics_Path,
  RentalManagerGuestSupportWebApiHandler_submitRequest,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GuestSupportGetHelpTopicsResponseWebDto,
  GuestSupportSubmitRequestWebDto,
  RentalManagerSupportHelpArticlesResponseDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetHelpArticlesParams {
  category?: string;
  topic?: string;
}

export type RentalManagerGuestSupportWebApiHandler_getHelpArticles_Options = UseQueryOptions<
  RentalManagerSupportHelpArticlesResponseDto,
  unknown,
  RentalManagerSupportHelpArticlesResponseDto,
  readonly [string, GetHelpArticlesParams]
>;

const RentalManagerGuestSupportWebApiHandler_getHelpArticles_GetKey = (getParams: GetHelpArticlesParams) =>
  [RentalManagerGuestSupportWebApiHandler_getHelpArticles_Path, getParams] as const;

export const RentalManagerGuestSupportWebApiHandler_getHelpArticles_queryOptions = (
  getParams: GetHelpArticlesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerGuestSupportWebApiHandler_getHelpArticles_GetKey(getParams),
    queryFn: () => RentalManagerGuestSupportWebApiHandler_getHelpArticles(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get help articles
 */
export const useRentalManagerGuestSupportWebApiHandler_getHelpArticles = (
  getParams: GetHelpArticlesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerGuestSupportWebApiHandler_getHelpArticles_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerGuestSupportWebApiHandler_getHelpArticles_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerGuestSupportWebApiHandler_getHelpArticles.getKey =
  RentalManagerGuestSupportWebApiHandler_getHelpArticles_GetKey;

export type RentalManagerGuestSupportWebApiHandler_getHelpTopics_Options = UseQueryOptions<
  GuestSupportGetHelpTopicsResponseWebDto,
  unknown,
  GuestSupportGetHelpTopicsResponseWebDto,
  readonly [string]
>;

const RentalManagerGuestSupportWebApiHandler_getHelpTopics_GetKey = () =>
  [RentalManagerGuestSupportWebApiHandler_getHelpTopics_Path] as const;

export const RentalManagerGuestSupportWebApiHandler_getHelpTopics_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerGuestSupportWebApiHandler_getHelpTopics_GetKey(),
    queryFn: () => RentalManagerGuestSupportWebApiHandler_getHelpTopics(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get help topics
 */
export const useRentalManagerGuestSupportWebApiHandler_getHelpTopics = ({
  httpClient,
  ...options
}: Omit<RentalManagerGuestSupportWebApiHandler_getHelpTopics_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerGuestSupportWebApiHandler_getHelpTopics_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerGuestSupportWebApiHandler_getHelpTopics.getKey =
  RentalManagerGuestSupportWebApiHandler_getHelpTopics_GetKey;

export interface RentalManagerGuestSupportWebApiHandler_submitRequest_Args {
  postData: GuestSupportSubmitRequestWebDto;
}

export type RentalManagerGuestSupportWebApiHandler_submitRequest_Options = UseMutationOptions<
  string,
  unknown,
  RentalManagerGuestSupportWebApiHandler_submitRequest_Args
>;

/**
 * Submit a support request
 */
export const useRentalManagerGuestSupportWebApiHandler_submitRequest = ({
  httpClient,
  ...options
}: Omit<RentalManagerGuestSupportWebApiHandler_submitRequest_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerGuestSupportWebApiHandler_submitRequest_Args) =>
      RentalManagerGuestSupportWebApiHandler_submitRequest(args.postData, httpClient),
  });
};
